import { Auth } from "aws-amplify";

const sendRequest = async (url, options, session) => {
  const headers = new Headers(options.headers);
  headers.set("Authorization", session.getIdToken().getJwtToken());

  return fetch(url, {
    ...options,
    headers,
  });
};

const forceRefreshSession = async () => {
  const user = await Auth.currentAuthenticatedUser();
  const currentSession = user.getSignInUserSession();
  const refreshToken = currentSession.getRefreshToken();

  return new Promise((resolve, reject) => {
    user.refreshSession(refreshToken, (error, refreshedSession) => {
      if (error) {
        reject(error);
        return;
      }

      resolve(refreshedSession);
    });
  });
};

export const authenticatedFetch = async (url, options = {}) => {
  let session = await Auth.currentSession();
  let response = await sendRequest(url, options, session);

  // If the request fails with a unauthorized error, refresh the session and retry the request
  if (response.status !== 401) {
    return response;
  }

  session = await forceRefreshSession();
  return sendRequest(url, options, session);
};
